<template>
  <div class="ep_cmp">
    <Menu />
    <div class="schead">
      <img
        class="icon_left"
        @click="back"
        src="~@/assets/pricing2/solo/bleft@2x.png"
        alt=""
      />
      <span class="head_text">套餐对比</span>
      <img
        class="icon_right"
        @click="close"
        src="~@/assets/pricing2/solo/bclose@2x.png"
        alt=""
      />
    </div>
    <div class="data_li">
      <div class="data_content">
        <div class="data_title">
          <p>专项权益</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">商业用途授权</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">用户数</p>
          <p class="data_tx tab_content2">1</p>
          <p class="data_tx tab_content3">1</p>
          <p class="data_tx tab_content4">3</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">设备数</p>
          <p class="data_tx tab_content2">5</p>
          <p class="data_tx tab_content3">5</p>
          <p class="data_tx tab_content4">200</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">通道数</p>
          <p class="data_tx tab_content2">1</p>
          <p class="data_tx tab_content3">1</p>
          <p class="data_tx tab_content4">1</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">SD-WAN加速</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">不限制转发带宽</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">最优画质</p>
          <p class="data_tx tab_content2">2K30FPS</p>
          <p class="data_tx tab_content3">4K60FPS</p>
          <p class="data_tx tab_content4">2K30FPS</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">端到端时延</p>
          <p class="data_tx tab_content2">最低延时&lt;70ms</p>
          <p class="data_tx tab_content3">最低延时&lt;40ms</p>
          <p class="data_tx tab_content4">最低延时&lt;70ms</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">鼠标加速通道</p>
          <p class="data_tx tab_content2">最高60hz</p>
          <p class="data_tx tab_content3">最高120hz</p>
          <p class="data_tx tab_content4">最高60hz</p>
        </div>
      </div>

      <div class="data_content">
        <div class="data_title">
          <p>专业远控</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">跨系统互连</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">文件传输</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">被控音频传输至主控</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">远程打印</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">文字聊天</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">远程命令行</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">禁用被控键鼠</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">远程摄像头</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">隐私屏</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <div class="ex1" :class="ex1 ? 'active' : ''">
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">文件拖拽传输</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">远程开机（WOL）</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">锁屏、重启、关机</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">锁定鼠标</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">远程鼠标</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">3D鼠标</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">同步剪贴板</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">分辨率自适应</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">发送组合快捷键</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">SSL+双重加密</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
        </div>
        <div class=" ">
          <p class="mtitle mfold" @click="changeEx('ex1')">
            <span class="text a2" v-if="ex1">收起</span>
            <span class="text a1" v-else>展开</span>
            <img class="a2" src="@/assets/pricing2/solo/pack_up@2x.png" alt=""  v-if="ex1">
            <img class="a1" src="@/assets/pricing2/solo/expand@2x.png" alt="" v-else>
          </p>
        </div>
      </div>
      <div class="data_content">
        <div class="data_title">
          <p>卓越办公体验</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">扩展虚拟屏</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">-</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">4:4:4 真彩</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">画质无损模式</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">数位板/手柄/摄像头/麦克风外接设备重定向</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">多屏控多屏</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">远控全球节点加速</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">文件传输全球节点加速</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">RDP Proxy  多控一</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">Connector</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">-</p>
        </div>
      </div>
      <div class="data_content">
        <div class="data_title">
          <p>高效运维支持</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">音频通话</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">控制安卓设备</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">工单队列申请协助</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">SOS客户免安装支持</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">主控端连接个人版设备</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">web远控个人版设备</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">通过控制台设备列表发起web主控</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
      </div>
      <div class="data_content">
        <div class="data_title">
          <p>灵活管理</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">资产信息管理</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">-</p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">批量下发工具栏模版</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">使用统计看板</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">隐藏远控工具栏中无权限的菜单</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">批量部署设备</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">批量文件分发</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">屏幕墙</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">屏幕墙Pro版</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">AD域导入用户及SSO登录</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <div class="ex2" :class="ex2 ? 'active' : ''">
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">飞书导入用户及SSO登录</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">企业微信导入用户及SSO登录</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
        </div>
        <div class=" ">
          <p class="mtitle mfold" @click="changeEx('ex2')">
            <span class="text a2" v-if="ex2">收起</span>
            <span class="text a1" v-else>展开</span>
            <img class="a2" src="@/assets/pricing2/solo/pack_up@2x.png" alt=""  v-if="ex2">
            <img class="a1" src="@/assets/pricing2/solo/expand@2x.png" alt="" v-else>
          </p>
        </div>
      </div>
      <div class="data_content">
        <div class="data_title">
          <p>权限安全及防护</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">各类权限策略实时下发</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">账号-设备绑定</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">企业码部署</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">双因子验证</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">实时监控报警</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">IP/MAC黑白名单</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">被控端防卸载保护</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">用户/设备分组管理</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">设备组权限策略</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <div class="ex3" :class="ex3 ? 'active' : ''">
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">远控权限模版</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
          <p class="line"></p>
          <div class="data_text da_zj">
            <p class="data_tx tab_content1">用户组权限策略</p>
            <p class="data_tx tab_content2">
              <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
            </p>
            <p class="data_tx tab_content3">
              <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
            </p>
            <p class="data_tx tab_content4">
              <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
            </p>
          </div>
        </div>
        <div class=" ">
          <p class="mtitle mfold" @click="changeEx('ex3')">
            <span class="text a2" v-if="ex3">收起</span>
            <span class="text a1" v-else>展开</span>
            <img class="a2" src="@/assets/pricing2/solo/pack_up@2x.png" alt=""  v-if="ex3">
            <img class="a1" src="@/assets/pricing2/solo/expand@2x.png" alt="" v-else>
          </p>
        </div>
      </div>
      <div class="data_content">
        <div class="data_title">
          <p>全方位信息安全保障</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">水印（明水印+暗水印）</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">临时用户</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">自定义用户有效期</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">强制隐私屏</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">-</p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">连接日志保存</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">文件传输日志</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">控制台操作日志</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">远控操作日志</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">云端加密录屏</p>
          <p class="data_tx tab_content2">可选购</p>
          <p class="data_tx tab_content3">可选购</p>
          <p class="data_tx tab_content4">可选购</p>                                                                                                                                                                                       
        </div>
      </div>
      <div class="data_content">
        <div class="data_title">
          <p>服务与支持</p>
        </div>
        <div class="data_tab da_zj">
          <p class="data_tx tab_content1 tab_tx1">能力</p>
          <p class="data_tx tab_content2 tab_tx2">远程办公</p>
          <p class="data_tx tab_content3 tab_tx3">高性能远程办公</p>
          <p class="data_tx tab_content4 tab_tx4">技术支持PRO</p>
        </div>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">VIP专属售后服务</p>
          <p class="data_tx tab_content2">
            <img class="img1" src="@/assets/pricing2/solo/chek1@2x.png" alt="">
          </p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>
        </div>
        <p class="line"></p>
        <div class="data_text da_zj">
          <p class="data_tx tab_content1">高级专家支持</p>
          <p class="data_tx tab_content2">-</p>
          <p class="data_tx tab_content3">
            <img class="img1" src="@/assets/pricing2/solo/chek2@2x.png" alt="">
          </p>
          <p class="data_tx tab_content4">
            <img class="img1" src="@/assets/pricing2/solo/chek3@2x.png" alt="">
          </p>                                                                                                                                                                                     
        </div>
      </div>
    </div>
    <div class="data_bx bz_bx" v-if="active_tab == 0">
      <div class="dboo">
        <a class="boo_btn" href="https://console.todesk.com/#/register"
          >免费试用</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import Menu from "@/components/menu";
export default {
  components: {
    Menu
  },
  data() {
    return {
      ex1: false,
      ex2: false,
      ex3: false,
      active_tab: 0,
    };
  },
  created() {
    // if (
    //   this.$route.query.tab &&
    //   [0, 1, 2, 3].indexOf(Number(this.$route.query.tab)) > -1
    // ) {
    //   this.active_tab = this.$route.query.tab;
    // }
  },
  methods: {
    close() {
      this.$router.push("/pricing_enterprise.html");
    },
    back() {
      this.$router.back();
    },
    changeEx(ex) {
      this[ex] = !this[ex];
    },
  },
};
</script>
<style lang="less" scoped>
.ep_cmp {
  .data_li {
    padding: 12px 16px 12px 16px;
    background: #ffffff;
    .data_content {
      width: 100%;
      border-radius: 8px;
      border: 1px solid #E5E6EB;
      overflow: hidden;
      margin-bottom: 24px;
      .data_title {
        background: #7A8499;
        height: 40px;
      }
      .data_title p {
        line-height: 36px;
        font-size: 16px;
        color: #ffffff;
        margin-left: 8px;
      }
      .data_tab {
        height: 40px;
        margin-top: -4px;
        overflow: hidden;
        border-radius: 8px 8px 0px 0px;
      }
      .data_text {
        height: 58px;
      }
      .line {
        height: 1px;
        background: #E5E6EB;
      }
      .da_zj{
        display: flex;
        .img1 {
          height: 20px;
          width: 20px;
        }
      }
      .data_tx {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        padding: 0px 12px;
        text-align: center;
        color: #20201F;
        word-break: break-word;
      }
      .data_text .data_tx {
        padding: 0px 8px;
      }
      .tab_tx1 {
        color: #20201F;
        background: #F2F3F5;
      }
      .tab_tx2 {
        color: #FFFFFF;
        background: #46B9EE; 
      }
      .tab_tx3 {
        color: #FFFFFF;
        background: #2E70D4;
      }
      .tab_tx4 {
        color: #FFFFFF;
        background: #45C1A3;
      }
      .tab_content1 {
        width: 84px;
      }
      .tab_content2 {
        width: 66px;
      }
      .tab_content3 {
        width: 66px;
      }
      .tab_content4 {
        width: 66px;
      }
      .mfold img {
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
      .mtitle {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        background-color: #F2F3F5;
        color: #0070F9;
        cursor: pointer;
        font-size: 12px;
      }
      .mtitle span,
      .mtitle img {
        display: inline-block;
        vertical-align: middle;
      }
      .ex1,
      .ex2,
      .ex3 {
        display: none;
      }
      .ex1.active,
      .ex2.active,
      .ex3.active {
        display: block;
      }
    }
  }
  .schead {
    width: 100%;
    height: 40px;
    background: #ffffff;
    // box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.06);
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .icon_left,
    .icon_right {
      width: 16px;
      height: 16px;
    }
    .head_text {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #131314;
    }
  }
  .tab_bx {
    height: 116px;
    background: #2085ff;
    padding-top: 30px;
    padding-bottom: 60px;
    display: flex;
    box-sizing: border-box;
    justify-content: space-around;
    .titem {
      font-size: 16px;
      text-align: center;
      position: relative;
      color: rgba(255, 255, 255, 0.6);
      height: 32px;
      &::after {
        position: absolute;
        content: "";
        background: #2085ff;
        width: 24px;
        height: 2px;
        border-radius: 1px;
        bottom: 0;
        left: calc(50% - 12px);
      }
    }
    .titem.active {
      color: #fff;
      &::after {
        background: #fff;
      }
    }
  }
  .data_bx {
    padding-top: 20px;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -30px;
    padding-bottom: 80px;
    .btitle {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      margin-bottom: 10px;
      color: #216ed8;
    }
    .dlist_items {
      padding: 10px;
      .part_title {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 10px;
        color: #83888f;
      }
      .di_item {
        height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 15px;
        padding-right: 15px;
        &.di_item2 {
          height: 60px;
        }
      }
      .di_item_title {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #383a3d;
      }
      .di_item_desc {
        display: flex;
        align-items: center;
        .icon_left {
          width: 34px;
          height: auto;
          margin-right: 6px;
        }
        .di_item_star {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }
        .di_item_text {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0f1012;
          line-height: 22px;
          text-align: right;
        }
      }
      .di_item_check {
        width: 20px;
        height: 20px;
        margin-left: 20px;
      }
    }
    .dboo {
      padding: 10px 20px;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
      // border-top: 1px solid rgba(0, 0, 0, 0.2);
      .boo_btn {
        width: 100%;
        line-height: 50px;
        text-align: center;
        border-radius: 4px;
        box-sizing: border-box;
        display: block;
        background: #1d64d0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  // 企业标准版
  .bz_bx {
    .di_item_count0:nth-of-type(odd),
    .di_item_count1:nth-of-type(even),
    .di_item_count2:nth-of-type(odd),
    .di_item_count3:nth-of-type(even),
    .di_item_count4:nth-of-type(even) {
      background: #f7f7f7;
    }
  }
  // 高性能设计
  .gx_bx {
    .di_item_count0:nth-of-type(odd),
    .di_item_count1:nth-of-type(odd),
    .di_item_count2:nth-of-type(even),
    .di_item_count3:nth-of-type(odd),
    .di_item_count4:nth-of-type(odd) {
      background: #f7f7f7;
    }
  }
  // 技术支持
  .js_bx {
    .di_item_count0:nth-of-type(odd),
    .di_item_count1:nth-of-type(odd),
    .di_item_count2:nth-of-type(even),
    .di_item_count3:nth-of-type(odd),
    .di_item_count4:nth-of-type(odd) {
      background: #f7f7f7;
    }
  }
  // 私有化部署
  .syh_bx {
    .di_item {
      align-items: flex-start;
      height: auto;
      padding-top: 12px;
      padding-bottom: 12px;
      .di_item_title {
        line-height: 20px;
      }
      .di_item_check {
        margin-top: -12px;
      }
    }
    .dlist_items {
      .di_item:nth-child(2n) {
        background: #fff;
      }
      .di_item:nth-of-type(2n - 1) {
        background: #f7f7f7;
      }
    }
  }
}
</style>
